import { Injectable } from '@angular/core';


@Injectable()
export class AuthenticationService {
    constructor(){

    }

    private _authToken: string;
    get authToken(){
        return this._authToken;
    }

    set authToken(authToken){
        this._authToken = authToken;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/services/authentication.service.ts